// Footer toggle menu
const accordionItems = document.querySelectorAll("footer .footer__menu-title");

accordionItems.forEach(item =>
  item.addEventListener("click", () => {
    const isItemOpen = item.parentNode.classList.contains("open");
    accordionItems.forEach(item => item.parentNode.classList.remove("open"));
    if (!isItemOpen) {
      item.parentNode.classList.toggle("open");
    }
  })
);
document.querySelector('.toggle---button').addEventListener('click', function() {
    var container = document.querySelector('.product__description');
    container.classList.toggle('expanded');
    this.textContent = this.textContent === "Show More" ? "Show Less" : "Show More";
});
